var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZendesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2500023,47.2989691 L60.2500023,100 L16.0000042,100 L60.2500023,47.2989691 Z M60.2500023,28.0030108 C60.2574821,40.2977034 50.3501424,50.2680412 38.1242549,50.2680412 C25.8983673,50.2680412 15.9925245,40.2946926 16.0000042,28 L60.2500023,28.0030108 Z M67.750002,100 C67.750002,87.7015094 77.6555116,77.7319588 89.875001,77.7319588 C102.09449,77.7319588 112,87.7015094 112,100 L67.750002,100 Z M67.750002,80.7010309 L67.750002,28 L112,28 L67.750002,80.7010309 Z",
    id: "Shape",
    fill: "#03363D",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendesk);
export default __webpack_public_path__ + "static/media/zendesk.973ed17aac694c1a51590860c26e1f23.svg";
export { ForwardRef as ReactComponent };